import gql from 'graphql-tag';

const GET_POLLS = gql`
    query getPolls($size: Int, $page: Int, $filters: [FilterInput]) {
        getPolls(size: $size, page: $page, filters: $filters) {
            internalCode
            totalRecords
            totalPage
            payload {
                idPoll
                namePoll
                title
                welcomeMessage
                monthsEvaluate {
                    id
                    months_evaluate
                }
                immediateActivation
                status
                dateUpdate
                userUpdate
                userCreate
                activationRange {
                    init
                    end
                }
                dateCreate
                questions {
                    idQuestion
                    question
                    idTypeQuestion
                    orden
                    limitSelect
                    startLabelNps
                    endLabelNps
                    conditions {
                        idOptions
                        idQuestion
                        idNextQuestion
                        idCondition
                    }
                    options {
                        idOption
                        idQuestion
                        description
                        orden
                        type
                        required
                    }
                }
                numberReponses
                minPollsAnswered
                associatedStore {
                    id
                    idStore
                    amount
                    status
                    flag
                }
            }
        }
    }
`;

export default GET_POLLS;
